/**
 * @Author: Alexander Silva Barbosa
 * @Date:   2023-05-07 23:48:27
 * @Last Modified by:   Alexander Silva Barbosa
 * @Last Modified time: 2023-05-07 23:55:05
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSE_Events = void 0;
const SSE_Events = exports.SSE_Events = {
  Notification: 'SSE_NOTIFICATION',
  Toast: 'SSE_TOAST'
};